module.exports = __webpack_public_path__ + "img/car_shina2_25.837b8abf.jpg";